import React from "react";
import {
  Drawer,
  Button,
  Input,
  Form,
  Table,
  Row,
  Col,
  notification,
  Popconfirm,
  Select,
  Radio,
  Tabs,
  Tag,
  Spin,
} from "antd";
import { Pie } from "@ant-design/charts";
import { withRouter } from "react-router-dom";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { axiosInstance } from "../../../commons/commons";
import {
  country,
  city,
  unit,
  community,
  subCommunity,
  developers,
  legalCompany,
  project,
  contacts,
  companyAll,
  cluster,
  phase,
  building,
} from "../../../constants/url";

class Unit extends React.Component {
  _isMounted = false;
  state = {
    drawerIsVisible: false,
    editFormFields: [],
    countryData: {
      list: [],
      selectedIndex: null,
    },
    cityData: {
      list: [],
      selectedIndex: null,
    },
    communityData: {
      list: [],
      selectedIndex: null,
    },
    subCommunityData: {
      list: [],
      selectedIndex: null,
    },
    developerData: {
      list: [],
      selectedIndex: null,
    },
    facilityData: {
      list: [],
      selectedIndex: [],
    },
    projectData: {
      list: [],
      selectedIndex: null,
    },
    buildingData: {
      list: [],
      selectedIndex: null,
    },
    unitTypeData: {
      list: [],
      selectedIndex: null,
    },
    unitSubTypeData: {
      list: [],
      selectedIndex: null,
    },
    unitStatusData: {
      list: [],
      selectedIndex: null,
    },
    unitSubStatusData: {
      list: [],
      selectedIndex: null,
    },
    bathData: {
      list: [],
      selectedIndex: null,
    },
    blockData: {
      list: [],
      selectedIndex: null,
    },
    bedroomData: {
      list: [],
      selectedIndex: null,
    },
    viewData: {
      list: [],
      selectedIndex: null,
    },
    floorData: {
      list: [],
      selectedIndex: null,
    },
    rentingPurposeData: {
      list: [],
      selectedIndex: null,
    },
    landlordData: {
      list: [],
      selectedIndex: null,
    },
    tableData: {
      list: [],
      loading: true,
    },
    visualizationData: [],
  };

  columns = [
    {
      title: "S.N",
      dataIndex: "SN",
      key: "SN",
      align: "center",
      fixed: "left",
      width: 80,
    },

    {
      title: "SysCode",
      dataIndex: "SysCode",
      key: "SysCode",
      align: "center",
      width: 150,
    },
    {
      title: "UserCode",
      dataIndex: "UserCode",
      key: "SysCode",
      align: "center",
      width: 150,
    },
    {
      title: "Unit No",
      dataIndex: "UnitNo",
      key: "UnitNo",
      align: "center",
      width: 120,
    },
    {
      title: "Status",
      dataIndex: ["RentalUnitSubStatus", "UserName"],
      key: "RentalUnitSubStatus",
      align: "center",
      width: 120,
      render: (value) => (
        <Tag
          color={value === "Rented" ? "green" : "red"}
          style={{ borderRadius: 20 }}
        >
          {value}
        </Tag>
      ),
    },
    {
      title: "Building",
      dataIndex: ["Building", "BuildingName"],
      key: "BuildingName",
      align: "center",
      width: 200,
    },
    {
      title: "Created At",
      dataIndex: "DateCreated",
      key: "DateCreated",
      align: "center",
      width: 150,
      render: (value) => (value ? value.split("T")[0] : "N/A"),
      sorter: (a, b) => new Date(a.DateCreated) - new Date(b.DateCreated),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      width: 110,
      render: (_, item) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <EditOutlined
              style={{ color: "#1890ff" }}
              onClick={async () => {
                const tmpList = [];
                let state = this.state;
                // populate information for this unit
                Object.keys(item).map((key) => {
                  tmpList.push({ name: key, value: item[key] });
                  return key;
                });
                // populate and override especially the dropdown informations
                for (let country of state.countryData.list)
                  if (item.CountryID === country.CountryID) {
                    state.countryData.selectedIndex =
                      state.countryData.list.indexOf(country);
                    tmpList.push({
                      name: "CountryID",
                      value:
                        "country+-" +
                        state.countryData.list.indexOf(country) +
                        "+-" +
                        country.UserName,
                    });
                    if (state.countryData.selectedIndex !== null)
                      await axiosInstance
                        .get(
                          city +
                            "?CountryID=" +
                            state.countryData.list[
                              state.countryData.selectedIndex
                            ].CountryID
                        )
                        .then((res) => {
                          if (res.data.success)
                            state.cityData = {
                              list: res.data.message,
                              selectedIndex: null,
                            };
                        })
                        .catch(() => {});
                    break;
                  }
                // reset country form if none selected or doesnot match
                if (state.countryData.selectedIndex === null)
                  tmpList.push({ name: "CountryID", value: null });
                for (let city of state.cityData.list)
                  if (item.CityID === city.CityID) {
                    state.cityData.selectedIndex =
                      state.cityData.list.indexOf(city);
                    tmpList.push({
                      name: "CityID",
                      value:
                        "city+-" +
                        state.cityData.list.indexOf(city) +
                        "+-" +
                        city.UserName,
                    });
                    if (state.cityData.selectedIndex !== null)
                      await axiosInstance
                        .get(
                          community +
                            "?CityID=" +
                            state.cityData.list[state.cityData.selectedIndex]
                              .CityID
                        )
                        .then((res) => {
                          if (res.data.success)
                            state.communityData = {
                              list: res.data.message,
                              selectedIndex: null,
                            };
                        })
                        .catch(() => {});
                    break;
                  }
                if (state.cityData.selectedIndex === null)
                  tmpList.push({ name: "CityID", value: null });
                for (let community of state.communityData.list)
                  if (item.CommunityID === community.CommunityID) {
                    state.communityData.selectedIndex =
                      state.communityData.list.indexOf(community);
                    tmpList.push({
                      name: "CommunityID",
                      value:
                        "community+-" +
                        state.communityData.list.indexOf(community) +
                        "+-" +
                        community.UserName,
                    });
                    if (state.communityData.selectedIndex !== null)
                      await axiosInstance
                        .get(
                          subCommunity +
                            "?CommunityID=" +
                            state.communityData.list[
                              state.communityData.selectedIndex
                            ].CommunityID
                        )
                        .then((res) => {
                          if (res.data.success)
                            state.subCommunityData = {
                              list: res.data.message,
                              selectedIndex: null,
                            };
                        })
                        .catch(() => {});
                    break;
                  }
                if (state.communityData.selectedIndex === null)
                  tmpList.push({ name: "CommunityID", value: null });
                for (let subCommunity of state.subCommunityData.list)
                  if (item.SubCommunityID === subCommunity.SubCommunityID) {
                    state.subCommunityData.selectedIndex =
                      state.subCommunityData.list.indexOf(subCommunity);
                    tmpList.push({
                      name: "SubCommunityID",
                      value:
                        "subCommunity+-" +
                        state.subCommunityData.list.indexOf(subCommunity) +
                        "+-" +
                        subCommunity.UserName,
                    });
                    break;
                  }
                if (state.subCommunityData.selectedIndex === null)
                  tmpList.push({ name: "SubCommunityID", value: null });
                if (item.UnitOwnerType) {
                  await axiosInstance
                    .get(item.UnitOwnerType === "I" ? contacts : companyAll)
                    .then((res) => {
                      if (res.data.success)
                        state.landlordData = {
                          list: res.data.message.rows,
                          selectedIndex: null,
                        };
                    })
                    .catch(() => {});
                  for (let landlord of state.landlordData.list)
                    if (
                      // could be company or contact
                      item.UnitOwnerID === landlord.ContactID ||
                      item.UnitOwnerID === landlord.CompanyID
                    ) {
                      state.landlordData.selectedIndex =
                        state.landlordData.list.indexOf(landlord);
                      tmpList.push({
                        name: "UnitOwnerID",
                        value:
                          "landlord+-" +
                          state.landlordData.list.indexOf(landlord) +
                          "+-" +
                          (landlord.CompanyName || landlord.ContactName),
                      });
                      break;
                    }
                }
                if (state.landlordData.selectedIndex === null)
                  tmpList.push({ name: "UnitOwnerID", value: null });
                for (let project of state.projectData.list)
                  if (item.ProjectID === project.ProjectID) {
                    state.projectData.selectedIndex =
                      state.projectData.list.indexOf(project);
                    tmpList.push({
                      name: "ProjectID",
                      value:
                        "project+-" +
                        state.projectData.list.indexOf(project) +
                        "+-" +
                        project.ProjectName,
                    });
                    if (state.projectData.selectedIndex !== null)
                      await axiosInstance
                        .get(
                          building +
                            "?ProjectID=" +
                            state.projectData.list[
                              state.projectData.selectedIndex
                            ].ProjectID
                        )
                        .then((res) => {
                          if (res.data.success)
                            state.buildingData = {
                              list: res.data.message,
                              selectedIndex: null,
                            };
                        })
                        .catch(() => {});
                    break;
                  }
                if (state.projectData.selectedIndex === null)
                  tmpList.push({ name: "ProjectID", value: null });
                for (let building of state.buildingData.list)
                  if (item.BuildingID === building.BuildingID) {
                    state.buildingData.selectedIndex =
                      state.buildingData.list.indexOf(building);
                    tmpList.push({
                      name: "BuildingID",
                      value:
                        "building+-" +
                        state.buildingData.list.indexOf(building) +
                        "+-" +
                        building.BuildingName,
                    });
                    break;
                  }
                if (state.buildingData.selectedIndex === null)
                  tmpList.push({ name: "BuildingID", value: null });
                for (let unitType of state.unitTypeData.list)
                  if (item.PurposeID === unitType.PropertyRendingPurposeID) {
                    state.unitTypeData.selectedIndex =
                      state.unitTypeData.list.indexOf(unitType);
                    tmpList.push({
                      name: "PurposeID",
                      value:
                        "unitType+-" +
                        state.unitTypeData.list.indexOf(unitType) +
                        "+-" +
                        unitType.UserName,
                    });
                    if (state.unitTypeData.selectedIndex !== null)
                      await axiosInstance
                        .get(
                          unit +
                            "/rentingSubPurpose?PropertyRendingPurposeID=" +
                            state.unitTypeData.list[
                              state.unitTypeData.selectedIndex
                            ].PropertyRendingPurposeID
                        )
                        .then((res) => {
                          if (res.data.success)
                            state.unitSubTypeData = {
                              list: res.data.message,
                              selectedIndex: null,
                            };
                        })
                        .catch(() => {});
                    break;
                  }
                if (state.unitTypeData.selectedIndex === null)
                  tmpList.push({ name: "PurposeID", value: null });
                for (let unitSubType of state.unitSubTypeData.list)
                  if (
                    item.SubPurposeID ===
                    unitSubType.PropertyRendingSubPurposeID
                  ) {
                    state.unitSubTypeData.selectedIndex =
                      state.unitSubTypeData.list.indexOf(unitSubType);
                    tmpList.push({
                      name: "SubPurposeID",
                      value:
                        "unitSubType+-" +
                        state.unitSubTypeData.list.indexOf(unitSubType) +
                        "+-" +
                        unitSubType.UserName,
                    });
                    break;
                  }
                if (state.unitSubTypeData.selectedIndex === null)
                  tmpList.push({ name: "SubPurposeID", value: null });
                for (let bath of state.bathData.list)
                  if (item.PropertyBathID === bath.PropertyBathID) {
                    state.bathData.selectedIndex =
                      state.bathData.list.indexOf(bath);
                    tmpList.push({
                      name: "PropertyBathID",
                      value:
                        "bath+-" +
                        state.bathData.list.indexOf(bath) +
                        "+-" +
                        bath.UserName,
                    });
                    break;
                  }
                if (state.bathData.selectedIndex === null)
                  tmpList.push({ name: "PropertyBathID", value: null });
                for (let block of state.blockData.list)
                  if (item.PropertyBlockID === block.PropertyBlockID) {
                    state.blockData.selectedIndex =
                      state.blockData.list.indexOf(block);
                    tmpList.push({
                      name: "PropertyBlockID",
                      value:
                        "block+-" +
                        state.blockData.list.indexOf(block) +
                        "+-" +
                        block.UserName,
                    });
                    break;
                  }
                if (state.blockData.selectedIndex === null)
                  tmpList.push({ name: "PropertyBlockID", value: null });
                for (let bedroom of state.bedroomData.list)
                  if (item.PropertySizeID === bedroom.PropertySizeID) {
                    state.bedroomData.selectedIndex =
                      state.bedroomData.list.indexOf(bedroom);
                    tmpList.push({
                      name: "PropertySizeID",
                      value:
                        "size+-" +
                        state.bedroomData.list.indexOf(bedroom) +
                        "+-" +
                        bedroom.UserName,
                    });
                    break;
                  }
                if (state.bedroomData.selectedIndex === null)
                  tmpList.push({ name: "PropertySizeID", value: null });
                for (let view of state.viewData.list)
                  if (item.PropertyViewID === view.PropertyViewID) {
                    state.viewData.selectedIndex =
                      state.viewData.list.indexOf(view);
                    tmpList.push({
                      name: "PropertyViewID",
                      value:
                        "view+-" +
                        state.viewData.list.indexOf(view) +
                        "+-" +
                        view.UserName,
                    });
                    break;
                  }
                if (state.viewData.selectedIndex === null)
                  tmpList.push({ name: "PropertyViewID", value: null });
                for (let floor of state.floorData.list)
                  if (item.PropertyFloorID === floor.PropertyFloorID) {
                    state.floorData.selectedIndex =
                      state.floorData.list.indexOf(floor);
                    tmpList.push({
                      name: "PropertyFloorID",
                      value:
                        "floor+-" +
                        state.floorData.list.indexOf(floor) +
                        "+-" +
                        floor.UserName,
                    });
                    break;
                  }
                if (state.floorData.selectedIndex === null)
                  tmpList.push({ name: "PropertyFloorID", value: null });
                for (let unitStatus of state.unitStatusData.list)
                  if (item.UnitStatusID === unitStatus.PropertyStatusID) {
                    state.unitStatusData.selectedIndex =
                      state.unitStatusData.list.indexOf(unitStatus);
                    tmpList.push({
                      name: "UnitStatusID",
                      value:
                        "unitStatus+-" +
                        state.unitStatusData.list.indexOf(unitStatus) +
                        "+-" +
                        unitStatus.UserName,
                    });
                    if (state.unitStatusData.selectedIndex !== null)
                      await axiosInstance
                        .get(
                          unit +
                            "/subStatus?PropertyStatusID=" +
                            state.unitStatusData.list[
                              state.unitStatusData.selectedIndex
                            ].PropertyStatusID
                        )
                        .then((res) => {
                          if (res.data.success)
                            state.unitSubStatusData = {
                              list: res.data.message,
                              selectedIndex: null,
                            };
                        })
                        .catch(() => {});
                    break;
                  }
                if (state.unitTypeData.selectedIndex === null)
                  tmpList.push({ name: "UnitStatusID", value: null });
                for (let unitSubStatus of state.unitSubStatusData.list)
                  if (
                    item.UnitSubStatusID === unitSubStatus.PropertySubStatusID
                  ) {
                    state.unitSubStatusData.selectedIndex =
                      state.unitSubStatusData.list.indexOf(unitSubStatus);
                    tmpList.push({
                      name: "UnitSubStatusID",
                      value:
                        "unitSubStatus+-" +
                        state.unitSubStatusData.list.indexOf(unitSubStatus) +
                        "+-" +
                        unitSubStatus.UserName,
                    });
                    break;
                  }
                if (state.unitSubStatusData.selectedIndex === null)
                  tmpList.push({ name: "UnitSubStatusID", value: null });
                for (let rentingPurpose of state.rentingPurposeData.list)
                  if (
                    item.VAT_RentingPurposeId ===
                    rentingPurpose.VAT_RentingPurposeId
                  ) {
                    state.rentingPurposeData.selectedIndex =
                      state.rentingPurposeData.list.indexOf(rentingPurpose);
                    tmpList.push({
                      name: "VAT_RentingPurposeId",
                      value:
                        "rentingPurpose+-" +
                        state.rentingPurposeData.list.indexOf(rentingPurpose) +
                        "+-" +
                        rentingPurpose.VAT_RentingPurpose,
                    });
                    break;
                  }
                if (state.rentingPurposeData.selectedIndex === null)
                  tmpList.push({ name: "VAT_RentingPurposeId", value: null });
                // facility filter
                for (let masterFacility of item.MasterUnitFacilities)
                  for (let facility of state.facilityData.list)
                    if (
                      masterFacility.UnitFacilityID === facility.UnitFacilityID
                    ) {
                      // push into array
                      state.facilityData.selectedIndex.push(
                        state.facilityData.list.indexOf(facility)
                      );
                      break;
                    }
                // populate facility as array since its mode is multiple
                tmpList.push({
                  name: "UnitFacilities",
                  value: state.facilityData.selectedIndex.map(
                    (index) =>
                      "facility+-" +
                      index +
                      "+-" +
                      state.facilityData.list[index].UserName
                  ),
                });
                state.editFormFields = tmpList;
                state.drawerIsVisible = true;
                this.setState(state);
              }}
            />
            <Popconfirm
              title="Are you sure to delete ?"
              onConfirm={() => {
                axiosInstance
                  .delete(unit + "/" + item.UnitID)
                  .then((res) => {
                    if (res.data.success)
                      notification.success({
                        duration: 3,
                        message: "Success",
                        description: res.data.message || "Done!",
                      });
                    else
                      notification.success({
                        duration: 3,
                        message: "Fail",
                        description:
                          res.data.message || "Something went wrong!",
                      });
                    this.getInitialState().then((st) => {
                      this.resetFields();
                      this.setState(st);
                    });
                  })
                  .catch(() => {});
              }}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <DeleteOutlined style={{ color: "red" }} />
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  formRef = null;

  resetFields = () => {
    if (this.formRef) {
      this.formRef.resetFields();
    }
  };

  getInitialState = async (drawerIsVisible) => {
    let state = {
      drawerIsVisible: drawerIsVisible || false,
      editFormFields: [],
      countryData: {
        list: [],
        selectedIndex: null,
      },
      cityData: {
        list: [],
        selectedIndex: null,
      },
      communityData: {
        list: [],
        selectedIndex: null,
      },
      subCommunityData: {
        list: [],
        selectedIndex: null,
      },
      developerData: {
        list: [],
        selectedIndex: null,
      },
      facilityData: {
        list: [],
        selectedIndex: [],
      },
      projectData: {
        list: [],
        selectedIndex: null,
      },
      buildingData: {
        list: [],
        selectedIndex: null,
      },
      unitTypeData: {
        list: [],
        selectedIndex: null,
      },
      unitSubTypeData: {
        list: [],
        selectedIndex: null,
      },
      unitStatusData: {
        list: [],
        selectedIndex: null,
      },
      unitSubStatusData: {
        list: [],
        selectedIndex: null,
      },
      rentingPurposeData: {
        list: [],
        selectedIndex: null,
      },
      bathData: {
        list: [],
        selectedIndex: null,
      },
      blockData: {
        list: [],
        selectedIndex: null,
      },
      bedroomData: {
        list: [],
        selectedIndex: null,
      },
      viewData: {
        list: [],
        selectedIndex: null,
      },
      floorData: {
        list: [],
        selectedIndex: null,
      },
      landlordData: {
        list: [],
        selectedIndex: null,
      },
      tableData: {
        list: this.state.tableData.list,
        loading: false,
      },
      visualizationData: [],
    };
    await axiosInstance
      .get(unit)
      .then((res) => {
        if (res.data.success) {
          let data = { Rented: 0, Vacant: 0 };
          state.tableData.list = res.data.message.map((unit, index) => {
            unit.SN = index + 1;
            unit.key = index;
            if (
              ((unit.RentalUnitSubStatus || {}).UserName || "")
                .toLowerCase()
                .indexOf("rent") !== -1
            )
              data.Rented += 1;
            else data.Vacant += 1;
            return unit;
          });
          state.visualizationData.push({ type: "Rented", value: data.Rented });
          state.visualizationData.push({ type: "Vacant", value: data.Vacant });
        }
      })
      .catch(() => {});
    await axiosInstance
      .get(project)
      .then((res) => {
        if (res.data.success) state.projectData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(country)
      .then((res) => {
        if (res.data.success) state.countryData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(developers)
      .then((res) => {
        if (res.data.success) state.developerData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(legalCompany)
      .then((res) => {
        if (res.data.success) state.companyData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(cluster)
      .then((res) => {
        if (res.data.success) state.clusterData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(phase)
      .then((res) => {
        if (res.data.success) state.phaseData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(unit + "/vatRentingPurpose")
      .then((res) => {
        if (res.data.success) state.rentingPurposeData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(unit + "/status")
      .then((res) => {
        if (res.data.success) state.unitStatusData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(unit + "/rentingPurpose")
      .then((res) => {
        if (res.data.success) state.unitTypeData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(unit + "/bath")
      .then((res) => {
        if (res.data.success) state.bathData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(unit + "/block")
      .then((res) => {
        if (res.data.success) state.blockData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(unit + "/bedroom")
      .then((res) => {
        if (res.data.success) state.bedroomData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(unit + "/floor")
      .then((res) => {
        if (res.data.success) state.floorData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(unit + "/view")
      .then((res) => {
        if (res.data.success) state.viewData.list = res.data.message;
      })
      .catch(() => {});
    return state;
  };

  onCreateNew = (drawerIsVisible = false) => {
    return this.formRef
      .validateFields()
      .then(async (values) => {
        this.setState({
          tableData: { list: this.state.tableData.list, loading: true },
        });
        values.CountryID = Number(
          this.state.countryData.list[values.CountryID.split("+-")[1]].CountryID
        );
        values.CityID = Number(
          this.state.cityData.list[values.CityID.split("+-")[1]].CityID
        );
        values.CommunityID = Number(
          this.state.communityData.list[values.CommunityID.split("+-")[1]]
            .CommunityID
        );
        values.SubCommunityID = Number(
          this.state.subCommunityData.list[values.SubCommunityID.split("+-")[1]]
            .SubCommunityID
        );
        values.ProjectID = Number(
          this.state.projectData.list[values.ProjectID.split("+-")[1]].ProjectID
        );
        values.BuildingID = Number(
          this.state.buildingData.list[values.BuildingID.split("+-")[1]]
            .BuildingID
        );
        values.PurposeID = Number(
          this.state.unitTypeData.list[values.PurposeID.split("+-")[1]]
            .PropertyRendingPurposeID
        );
        values.SubPurposeID = Number(
          this.state.unitSubTypeData.list[values.SubPurposeID.split("+-")[1]]
            .PropertyRendingSubPurposeID
        );
        if (values.PropertyBathID)
          values.PropertyBathID = Number(
            this.state.bathData.list[values.PropertyBathID.split("+-")[1]]
              .PropertyBathID
          );
        if (values.PropertyBlockID)
          values.PropertyBlockID = Number(
            this.state.blockData.list[values.PropertyBlockID.split("+-")[1]]
              .PropertyBlockID
          );
        if (values.PropertySizeID)
          values.PropertySizeID = Number(
            this.state.bedroomData.list[values.PropertySizeID.split("+-")[1]]
              .PropertySizeID
          );
        if (values.PropertyViewID)
          values.PropertyViewID = Number(
            this.state.viewData.list[values.PropertyViewID.split("+-")[1]]
              .PropertyViewID
          );
        if (values.PropertyFloorID)
          values.PropertyFloorID = Number(
            this.state.floorData.list[values.PropertyFloorID.split("+-")[1]]
              .PropertyFloorID
          );
        if (values.UnitStatusID)
          values.UnitStatusID = Number(
            this.state.unitStatusData.list[values.UnitStatusID.split("+-")[1]]
              .PropertyStatusID
          );
        else values.UnitStatusID = 1;
        if (values.UnitSubStatusID)
          values.UnitSubStatusID = Number(
            this.state.unitSubStatusData.list[
              values.UnitSubStatusID.split("+-")[1]
            ].PropertySubStatusID
          );
        else values.UnitSubStatusID = 1;
        if (values.VAT_RentingPurposeId)
          values.VAT_RentingPurposeId = Number(
            this.state.rentingPurposeData.list[
              values.VAT_RentingPurposeId.split("+-")[1]
            ].VAT_RentingPurposeId
          );
        if (values.UnitOwnerID)
          values.UnitOwnerID = Number(
            this.state.landlordData.list[values.UnitOwnerID.split("+-")[1]][
              values.UnitOwnerType === "I" ? "ContactID" : "CompanyID"
            ]
          );
        if (values.UnitFacilities)
          values.UnitFacilities =
            values.UnitFacilities.map((facility) =>
              Number(
                this.state.facilityData.list[facility.split("+-")[1]]
                  .UnitFacilityID
              )
            ) || [];
        await (this.state.editFormFields.length
          ? axiosInstance.put(unit, values)
          : axiosInstance.post(unit, values)
        )
          .then((res) => {
            if (res && res.data.success) {
              notification.success({
                duration: 3,
                message: "Success",
                description: res.data.message || "Done!",
              });
              this.getInitialState(drawerIsVisible).then((st) => {
                this.resetFields();
                this.setState(st);
              });
            } else
              notification.error({
                message: "Fail",
                description: res.data.message || "Something went wrong!",
              });
          })
          .catch(() => {
            this.setState({
              tableData: { list: this.state.tableData.list, loading: false },
            });
          });
      })
      .catch((err) => {
        this.setState({
          tableData: { list: this.state.tableData.list, loading: false },
        });
      });
  };

  onChange = (value) => {
    if (!value) return;
    let type, theIndex;
    /**
     * check if onchange is for division or not.
     * if division, then value will be type of array
     * since its in multiple mode.
     */
    if (typeof value === "object") {
      theIndex = [];
      for (let division of value) {
        type = division.split("+-")[0];
        theIndex.push(division.split("+-")[1]);
      }
    } else if (value === "I") {
      // landlord radio button contact
      return axiosInstance
        .get(contacts + "?ContactCategoryID=2&ContactSubCategoryID=2")
        .then((res) => {
          if (res.data.success)
            this.setState({
              landlordData: {
                list: res.data.message.rows,
                selectedIndex: null,
              },
            });
        })
        .catch(() => {});
    } else if (value === "C") {
      // landlord radio button company
      return axiosInstance
        .get(companyAll)
        .then((res) => {
          if (res.data.success)
            this.setState({
              landlordData: {
                list: res.data.message.rows,
                selectedIndex: null,
              },
            });
        })
        .catch(() => {});
    } else {
      type = value.split("+-")[0];
      theIndex = value.split("+-")[1];
    }
    switch (type) {
      case "project":
        this.setState(
          {
            projectData: {
              list: this.state.projectData.list,
              selectedIndex: theIndex,
            },
          },
          () =>
            axiosInstance
              .get(
                building +
                  "?ProjectID=" +
                  this.state.projectData.list[
                    this.state.projectData.selectedIndex
                  ].ProjectID
              )
              .then((res) => {
                if (res.data.success)
                  this.setState({
                    buildingData: {
                      list: res.data.message,
                      selectedIndex: [],
                    },
                  });
              })
              .catch(() => {})
        );
        break;
      case "country":
        this.setState(
          {
            countryData: {
              list: this.state.countryData.list,
              selectedIndex: theIndex,
            },
            cityData: {
              list: [],
              selectedIndex: null,
            },
            communityData: {
              list: [],
              selectedIndex: null,
            },
            subCommunityData: {
              list: [],
              selectedIndex: null,
            },
          },
          () =>
            axiosInstance
              .get(
                city +
                  "?CountryID=" +
                  this.state.countryData.list[
                    this.state.countryData.selectedIndex
                  ].CountryID
              )
              .then((res) => {
                if (res.data.success)
                  this.setState({
                    cityData: {
                      list: res.data.message,
                      selectedIndex: null,
                    },
                  });
              })
              .catch(() => {})
        );
        break;
      case "city":
        this.setState(
          {
            cityData: {
              list: this.state.cityData.list,
              selectedIndex: theIndex,
            },
            communityData: {
              list: [],
              selectedIndex: null,
            },
            subCommunityData: {
              list: [],
              selectedIndex: null,
            },
          },
          () =>
            axiosInstance
              .get(
                community +
                  "?CityID=" +
                  this.state.cityData.list[this.state.cityData.selectedIndex]
                    .CityID
              )
              .then((res) => {
                if (res.data.success)
                  this.setState({
                    communityData: {
                      list: res.data.message,
                      selectedIndex: null,
                    },
                  });
              })
              .catch(() => {})
        );
        break;
      case "community":
        this.setState(
          {
            communityData: {
              list: this.state.communityData.list,
              selectedIndex: theIndex,
            },
            subCommunityData: {
              list: [],
              selectedIndex: null,
            },
          },
          () =>
            axiosInstance
              .get(
                subCommunity +
                  "?CommunityID=" +
                  this.state.communityData.list[
                    this.state.communityData.selectedIndex
                  ].CommunityID
              )
              .then((res) => {
                if (res.data.success)
                  this.setState({
                    subCommunityData: {
                      list: res.data.message,
                      selectedIndex: null,
                    },
                  });
              })
              .catch(() => {})
        );
        break;
      case "unitStatus":
        this.setState(
          {
            unitStatusData: {
              list: this.state.unitStatusData.list,
              selectedIndex: theIndex,
            },
            unitSubStatusData: {
              list: [],
              selectedIndex: null,
            },
          },
          () =>
            axiosInstance
              .get(
                unit +
                  "/subStatus?PropertyStatusID=" +
                  this.state.unitStatusData.list[
                    this.state.unitStatusData.selectedIndex
                  ].PropertyStatusID
              )
              .then((res) => {
                if (res.data.success)
                  this.setState({
                    unitSubStatusData: {
                      list: res.data.message,
                      selectedIndex: null,
                    },
                  });
              })
              .catch(() => {})
        );
        break;
      case "unitType":
        this.setState(
          {
            unitTypeData: {
              list: this.state.unitTypeData.list,
              selectedIndex: theIndex,
            },
            unitSubTypeData: {
              list: [],
              selectedIndex: null,
            },
          },
          () =>
            axiosInstance
              .get(
                unit +
                  "/rentingSubPurpose?PropertyRendingPurposeID=" +
                  this.state.unitTypeData.list[
                    this.state.unitTypeData.selectedIndex
                  ].PropertyRendingPurposeID
              )
              .then((res) => {
                if (res.data.success)
                  this.setState({
                    unitSubTypeData: {
                      list: res.data.message,
                      selectedIndex: null,
                    },
                  });
              })
              .catch(() => {})
        );
        break;
      default:
        break;
    }
  };

  onReset = () => {
    this.getInitialState().then((st) => this.setState(st));
  };

  componentDidMount() {
    this._isMounted = true;
    this.getInitialState().then((st) =>
      this._isMounted ? this.setState(st) : null
    );
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <div>
        <Drawer
          title="New Unit"
          placement="right"
          closable={false}
          onClose={() => {
            this.resetFields();
            this.setState({ editFormFields: [], drawerIsVisible: false });
          }}
          visible={this.state.drawerIsVisible}
          width={window.innerWidth - 40 > 400 ? 380 : window.innerWidth - 40}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
              }}
            >
              <Button
                name="create"
                onClick={() => this.onCreateNew()}
                type="primary"
                style={{ borderRadius: 20 }}
              >
                {this.state.editFormFields.length ? "Save" : "Create"}
              </Button>
              {!this.state.editFormFields.length ? (
                <Button
                  style={{ borderRadius: 20 }}
                  onClick={() => this.onCreateNew(true)}
                  type="primary"
                >
                  Create and add another
                </Button>
              ) : null}
              <Button
                style={{ borderRadius: 20 }}
                onClick={() => {
                  this.resetFields();
                  this.setState({
                    editFormFields: [],
                    drawerIsVisible: this.state.editFormFields.length > 0,
                  });
                }}
              >
                Cancel
              </Button>
            </div>
          }
        >
          <Form
            layout="horizontal"
            colon={false}
            ref={(ref) => (ref ? (this.formRef = ref) : null)}
            fields={this.state.editFormFields}
            requiredMark
          >
            <Form.Item
              key="UnitID"
              name="UnitID"
              label="UnitID"
              labelAlign="left"
              labelCol={{ span: 24 }}
              hidden
              rules={[{ required: false, message: "Please enter unit id" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="UserCode"
              name="UserCode"
              label="User Code"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please enter user code" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="UnitNo"
              name="UnitNo"
              label="UnitNo"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please enter unit no" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="CountryID"
              name="CountryID"
              label="Country"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select country" }]}
            >
              <Select
                showSearch
                placeholder="Select a country"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.countryData.list.map((country, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"country+-" + index + "+-" + country.UserName}
                    >
                      {country.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="CityID"
              name="CityID"
              label="City"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select city" }]}
            >
              <Select
                showSearch
                placeholder="Select a city"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.cityData.list.map((city, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"city+-" + index + "+-" + city.UserName}
                    >
                      {city.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="CommunityID"
              name="CommunityID"
              label="Community"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select community" }]}
            >
              <Select
                showSearch
                placeholder="Select a community"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.communityData.list.map((community, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"community+-" + index + "+-" + community.UserName}
                    >
                      {community.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="SubCommunityID"
              name="SubCommunityID"
              label="Sub Community"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: true, message: "Please select sub community" },
              ]}
            >
              <Select
                showSearch
                placeholder="Select a sub community"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.subCommunityData.list.map((subCommunity, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={
                        "subCommunity+-" + index + "+-" + subCommunity.UserName
                      }
                    >
                      {subCommunity.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="ProjectID"
              name="ProjectID"
              label="Project"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select a project" }]}
            >
              <Select
                showSearch
                placeholder="Select project"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.projectData.list.map((project, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"project+-" + index + "+-" + project.ProjectName}
                    >
                      {project.ProjectName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="BuildingID"
              name="BuildingID"
              label="Building"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select a building" }]}
            >
              <Select
                showSearch
                placeholder="Select building"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.buildingData.list.map((building, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={
                        "building+-" + index + "+-" + building.BuildingName
                      }
                    >
                      {building.BuildingName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="PurposeID"
              name="PurposeID"
              label="Unit Type"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select unit type" }]}
            >
              <Select
                showSearch
                placeholder="Select unit type"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.unitTypeData.list.map((unitType, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"unitType+-" + index + "+-" + unitType.UserName}
                    >
                      {unitType.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="SubPurposeID"
              name="SubPurposeID"
              label="Unit Usage"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: true, message: "Please select unit sub type" },
              ]}
            >
              <Select
                showSearch
                placeholder="Select unit sub type"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.unitSubTypeData.list.map((unitSubType, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={
                        "unitSubType+-" + index + "+-" + unitSubType.UserName
                      }
                    >
                      {unitSubType.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="PropertyBathID"
              name="PropertyBathID"
              label="Bath"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please select bath" }]}
            >
              <Select
                showSearch
                placeholder="Select bath"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.bathData.list.map((bath, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"bath+-" + index + "+-" + bath.UserName}
                    >
                      {bath.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="PropertyBlockID"
              name="PropertyBlockID"
              label="Block"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please select block" }]}
            >
              <Select
                showSearch
                placeholder="Select block"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.blockData.list.map((block, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"block+-" + index + "+-" + block.UserName}
                    >
                      {block.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="PropertySizeID"
              name="PropertySizeID"
              label="Bedroom"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please select size" }]}
            >
              <Select
                showSearch
                placeholder="Select size"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.bedroomData.list.map((size, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"size+-" + index + "+-" + size.UserName}
                    >
                      {size.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="PropertyViewID"
              name="PropertyViewID"
              label="View"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please select view" }]}
            >
              <Select
                showSearch
                placeholder="Select view"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.viewData.list.map((view, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"view+-" + index + "+-" + view.UserName}
                    >
                      {view.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="PropertyFloorID"
              name="PropertyFloorID"
              label="Floor"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please select floor" }]}
            >
              <Select
                showSearch
                placeholder="Select floor"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.floorData.list.map((floor, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"floor+-" + index + "+-" + floor.UserName}
                    >
                      {floor.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="UnitStatusID"
              name="UnitStatusID"
              label="Unit Status"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: false, message: "Please select unit status" },
              ]}
            >
              <Select
                showSearch
                placeholder="Select unit status"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.unitStatusData.list.map((unitStatus, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={
                        "unitStatus+-" + index + "+-" + unitStatus.UserName
                      }
                    >
                      {unitStatus.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="UnitSubStatusID"
              name="UnitSubStatusID"
              label="Unit SubStatus"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: false, message: "Please select unit sub status" },
              ]}
            >
              <Select
                showSearch
                placeholder="Select unit sub status"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.unitSubStatusData.list.map(
                  (unitSubStatus, index) => {
                    return (
                      <Select.Option
                        key={index}
                        value={
                          "unitSubStatus+-" +
                          index +
                          "+-" +
                          unitSubStatus.UserName
                        }
                      >
                        {unitSubStatus.UserName}
                      </Select.Option>
                    );
                  }
                )}
              </Select>
            </Form.Item>
            <Form.Item
              key="VAT_RentingPurposeId"
              name="VAT_RentingPurposeId"
              label="Renting Purpose"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: false, message: "Please select renting purpose" },
              ]}
            >
              <Select
                showSearch
                placeholder="Select renting purpose"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.rentingPurposeData.list.map(
                  (rentingPurpose, index) => {
                    return (
                      <Select.Option
                        key={index}
                        value={
                          "rentingPurpose+-" +
                          index +
                          "+-" +
                          rentingPurpose.VAT_RentingPurpose
                        }
                      >
                        {rentingPurpose.VAT_RentingPurpose}
                      </Select.Option>
                    );
                  }
                )}
              </Select>
            </Form.Item>
            <Form.Item
              key="TotalParking"
              name="TotalParking"
              label="No. of parking"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: false, message: "Please enter no. of parking" },
              ]}
            >
              <Input type="number"></Input>
            </Form.Item>
            <Form.Item
              key="UnitOwnerType"
              name="UnitOwnerType"
              label="Unit Owner Type"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: false, message: "Please select unit owner type" },
              ]}
            >
              <Radio.Group
                // value={this.state.contactCompanyRadio}
                onChange={(e) => this.onChange(e.target.value)}
              >
                <Radio value="I">Contact</Radio>
                <Radio value="C">Company</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              key="UnitOwnerID"
              name="UnitOwnerID"
              label="Owner"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please select owner" }]}
            >
              <Select
                allowClear
                showSearch
                style={{
                  width: "100%",
                }}
                placeholder="Select a owner"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                filterSort={(optionA, optionB) =>
                  optionA.children
                    .toLowerCase()
                    .localeCompare(optionB.children.toLowerCase())
                }
              >
                {this.state.landlordData.list.map((lord, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={
                        "landlord+-" +
                        index +
                        "+-" +
                        (lord.ContactName || lord.CompanyName)
                      }
                    >
                      {lord.ContactName || lord.CompanyName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="UnitFeatures"
              name="UnitFeatures"
              label="Unit Features"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter unit features",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="UnitFacilities"
              name="UnitFacilities"
              label="Unit Facilities"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please select unit facility(s)",
                },
              ]}
            >
              <Select
                showSearch
                mode="multiple"
                placeholder="Select facility(s)"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.facilityData.list.map((facility, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"facility+-" + index + "+-" + facility.UserName}
                    >
                      {facility.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="Longitude"
              name="Longitude"
              label="Longitude"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter longitude",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="Latitude"
              name="Latitude"
              label="Longitude"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter Latitude",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="ConsumerNo"
              name="ConsumerNo"
              label="Consumer No."
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter consumer number",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Tabs defaultActiveKey="2">
              <Tabs.TabPane tab="Sales Pricing" key="1" disabled>
                <h3>Area (Sq. ft.) and Rate (AED) Calculation</h3>
                <Form.Item
                  key="CarpertArea"
                  name="CarpertArea"
                  label="Carpet Area"
                  labelAlign="left"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: false,
                      message: "Please enter carpet area",
                    },
                  ]}
                >
                  <Input type="number"></Input>
                </Form.Item>
                <Form.Item
                  key="BalconyArea"
                  name="BalconyArea"
                  label="Balcony Area"
                  labelAlign="left"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: false,
                      message: "Please enter balcony area",
                    },
                  ]}
                >
                  <Input type="number"></Input>
                </Form.Item>
                <Form.Item
                  key="TerraceArea"
                  name="TerraceArea"
                  label="Terrace Area"
                  labelAlign="left"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: false,
                      message: "Please enter terrace area",
                    },
                  ]}
                >
                  <Input type="number"></Input>
                </Form.Item>
                <Form.Item
                  key="Sellablearea"
                  name="Sellablearea"
                  label="Total Sellable Area"
                  labelAlign="left"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: false,
                      message: "Please enter total sellable area",
                    },
                  ]}
                >
                  <Input type="number"></Input>
                </Form.Item>
                <Form.Item
                  key="PerCABalcony"
                  name="PerCABalcony"
                  label="% of Balcony Area"
                  labelAlign="left"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: false,
                      message: "Please enter % of balcony area",
                    },
                  ]}
                >
                  <Input type="number"></Input>
                </Form.Item>
                <Form.Item
                  key="PerCATerrace"
                  name="PerCATerrace"
                  label="% of Terrace Area"
                  labelAlign="left"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: false,
                      message: "Please enter % of terrace area",
                    },
                  ]}
                >
                  <Input type="number"></Input>
                </Form.Item>
                <Form.Item
                  key="RatePerSqft"
                  name="RatePerSqft"
                  label="Price per Sqf"
                  labelAlign="left"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: false,
                      message: "Please enter rate per sq. ft.",
                    },
                  ]}
                >
                  <Input type="number"></Input>
                </Form.Item>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Rental Pricing" key="2">
                <Form.Item
                  key="RentMethod"
                  name="RentMethod"
                  label="Rent Method"
                  labelAlign="left"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: false,
                      message: "Please select rent method",
                    },
                  ]}
                >
                  <Radio.Group
                    // value={this.state.contactCompanyRadio}
                    onChange={(e) => this.onChange(e.target.value)}
                  >
                    <Radio value="L">Lumpsum</Radio>
                    <Radio value="S">Sq. ft.</Radio>
                  </Radio.Group>
                </Form.Item>
                <Form.Item
                  key="RentableArea"
                  name="RentableArea"
                  label="Rentable Area"
                  labelAlign="left"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: false,
                      message: "Please enter rentable area",
                    },
                  ]}
                >
                  <Input type="number"></Input>
                </Form.Item>
                <Form.Item
                  key="RentableSqftRate"
                  name="RentableSqftRate"
                  label="Price per Sq. ft. (P.A)"
                  labelAlign="left"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: false,
                      message: "Please enter rentable rate per sq. ft.",
                    },
                  ]}
                >
                  <Input type="number"></Input>
                </Form.Item>
                <Form.Item
                  key="RentableSqftPrice"
                  name="RentableSqftPrice"
                  label="Rental Price"
                  labelAlign="left"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: false,
                      message: "Please enter rentable price",
                    },
                  ]}
                >
                  <Input type="number"></Input>
                </Form.Item>
                <Form.Item
                  key="AnualLumsumRent"
                  name="AnualLumsumRent"
                  label="Lumpsum Rent(P.A)"
                  labelAlign="left"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: false,
                      message: "Please enter lumpsum rent",
                    },
                  ]}
                >
                  <Input type="number"></Input>
                </Form.Item>
              </Tabs.TabPane>
            </Tabs>
          </Form>
        </Drawer>
        <Row style={{ margin: "10px 10px 10px 10px" }}>
          <Col span={4}></Col>
          <Col span={16} style={{ textAlign: "center" }}>
            <h3>Unit</h3>
          </Col>
          <Col span={4} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              onClick={() => {
                this.setState({ drawerIsVisible: true });
              }}
              style={{ borderRadius: 20 }}
            >
              New
            </Button>
          </Col>
        </Row>
        <Spin
          spinning={this.state.tableData.loading}
          tip="fetching and populating data..."
        >
          <Row gutter={48} style={{ paddingLeft: 10, paddingRight: 10 }}>
            {this.state.tableData.list.length ? (
              <>
                <Col span={12} xs={24} sm={24} md={8} lg={12}>
                  <Row>
                    <Col
                      span={24}
                      style={{
                        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                        transition: "0.3s",
                        // borderRadius: 20,
                        width: "100%",
                        padding: 10,
                      }}
                    >
                      <Pie
                        {...{
                          data: this.state.visualizationData,
                          appendPadding: 10,
                          angleField: "value",
                          colorField: "type",
                          // color: ({ type }) => {
                          //   if (type === "Rented") {
                          //     return "#a0d911";
                          //   }
                          //   return "#ff7875";
                          // },
                          radius: 0.75,
                          label: {
                            type: "inner",
                            offset: "-30%",
                            content: ({ value }) => value + " unit(s)",
                            style: {
                              fontSize: 14,
                              textAlign: "center",
                            },
                          },
                          interactions: [
                            {
                              type: "pie-legend-active",
                            },
                            {
                              type: "element-active",
                            },
                          ],
                          // (innerHeight-headerFooter-viewSearchRow)/2-marginTop-for-Column
                          height: (window.innerHeight - 98 - 50) / 2,
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={0}
                  xs={24}
                  sm={24}
                  md={0}
                  lg={0}
                  style={{ marginTop: 10 }}
                ></Col>
              </>
            ) : null}
            <Col
              {...(this.state.tableData.list.length
                ? { span: 12, xs: 24, sm: 24, md: 16, lg: 12 }
                : { span: 24 })}
            >
              <Table
                // loading={this.state.tableData.loading}
                dataSource={this.state.tableData.list}
                columns={this.columns}
                scroll={{ y: window.innerHeight - 290 }}
                pagination={{
                  size: "small",
                  disabled: false,
                  defaultPageSize: 20,
                  showQuickJumper: true,
                  showSizeChanger: true,
                  total: this.state.tableData.list.length,
                }}
                style={{
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                  transition: "0.3s",
                  borderRadius: 20,
                  width: "100%",
                }}
              ></Table>
            </Col>
          </Row>
        </Spin>
      </div>
    );
  }
}

export default withRouter(Unit);
